//this has been made static to get round legacy issues with inject etc
//will convert after sub components fully converted

import { runInAction } from 'mobx';
import Moment from 'moment';
import AppointmentStore from './appointment-store';
import view from './diary-view-store';
import Schedule from './schedule-store';
import SessionStore from './session-store';
import StatsStore from './stats-store';

class DiaryStore {
  onAppointmentUpdate(appointment) {
    let date = new Moment(appointment.startDateTime).format('YYYY-MM-DD');
    let update = { [date]: [appointment] };
    this.onMerge('appointments', update);
  }

  onMerge(mode, update) {
    let key = view.resourceMode === 'room' ? 'roomId' : 'practitionerId';
    Schedule.onMerge(mode, key, update);
    StatsStore.onLoad(Schedule.keys);
  }

  onRemove(mode, update) {
    let key = view.resourceMode === 'room' ? 'roomId' : 'practitionerId';
    Schedule.onRemove(mode, key, update);
    StatsStore.onLoad(Schedule.keys);
  }

  _getById(id) {
    let appt = null;

    Schedule.blocks.forEach((block) => {
      if (!!appt) {
        return;
      }
      block.resources.forEach((resource) => {
        if (!!appt) {
          return;
        }
        appt = resource.appointments.get(`evt-appt-${id}`);
      });
    });

    return appt;
  }

  // hack method until quickbill is sorted
  // do not extend functionality like this
  onUpdateById(id, update) {
    let appt = this._getById(id);
    if (!appt) {
      return;
    }
    let date = new Moment(appt.startDateTime).format('YYYY-MM-DD');
    let upd = Object.assign({}, appt, update);
    this.onMerge('appointments', { [date]: [upd] });
  }

  onUpdateAlert(appointmentId: Number, hasAlert: boolean) {
    let appt = this._getById(appointmentId);

    if (!appt) {
      return;
    }

    appt.alert = hasAlert;
  }

  updateAppointment(appt) {
    view.processing = true;
    let originalStart = appt.startDateTime;
    let originalEnd = appt.endDateTime;

    let store = view.mode !== 'session' ? AppointmentStore : SessionStore;
    return new Promise((resolve, reject) => {
      store
        .onUpdate(appt)
        .then((res) => {
          resolve(res.body.result);
        })
        .catch((err) => {
          appt.startDateTime = originalStart;
          appt.endDateTime = originalEnd;
          reject(err.response.body.responseStatus);
        })
        .finally(() => {
          runInAction(() => {
            view.processing = false;
          });
        });
    });
  }
}

export default new DiaryStore();
